
import Header from "../../header";
import Footer from "../../footer";
import ContactForm from "../../contactcomponents/contactform";
import BannerFooter from "../productpages/bannerForFooter";
import technicalassistanceimage from '../../../images/footerLinksImages/support/technicalassistance.png'
function TechnicalAssistance() {
    const keywords = [
        { title: "Troubleshooting Support", summary: "Resolve hardware and software issues quickly with expert troubleshooting assistance." },
        { title: "System Maintenance", summary: "Routine checkups and system updates to ensure optimal performance and security." },
        { title: "Installation Support", summary: "Step-by-step guidance to ensure the smooth installation of software and hardware." },
        { title: "Network Setup", summary: "Expert assistance in setting up and optimizing your network infrastructure." },
        { title: "Data Backup & Recovery", summary: "Secure backup solutions and data recovery services to protect your critical information." },
        { title: "Software Configuration", summary: "Ensure your software is configured correctly to meet your business needs and maximize performance." },
        { title: "Cloud Services", summary: "Support in setting up, managing, and scaling your cloud infrastructure for flexibility and security." },
        { title: "Cybersecurity Solutions", summary: "Protect your business from cyber threats with proactive security measures and real-time monitoring." },
        { title: "IT Consulting", summary: "Consult with experts to improve your IT infrastructure and make informed technology decisions." },
        { title: "Technical Training", summary: "Provide your team with the skills to effectively use new technologies and systems through tailored training." },
      ];
      
    return (<>
        <Header />
       
        <BannerFooter
            title="Technical Assistance"
            text="Technical Assistance is a critical service that provides customers with expert support for addressing technical issues related to products or services. This includes troubleshooting, system maintenance, installation support, software configuration, and network setup. The goal is to resolve technical problems efficiently and ensure that systems operate optimally. Whether it's helping with complex software configurations, providing cloud service support, or ensuring cybersecurity measures are in place, Technical Assistance is essential for maintaining smooth business operations. The service also offers data recovery, IT consulting, and technical training, helping businesses stay ahead with reliable, cutting-edge support."
            imageone={technicalassistanceimage}
            imagetwo={technicalassistanceimage}
        />
        <div className="container-fluid py-5 bg-light">
  <div className="container p-4 shadow-lg bg-white rounded">
    <h2 className="text-center mb-4">Technical Assistance</h2>
    <div className="accordion" id="technicalAssistanceAccordion">
      {keywords.map((item, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header" id={`heading-${index}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${index}`}
              aria-expanded="false"
              aria-controls={`collapse-${index}`}
              style={{ transition: "all 0.3s ease" }}
            >
              {item.title}
            </button>
          </h2>
          <div
            id={`collapse-${index}`}
            className="accordion-collapse collapse"
            aria-labelledby={`heading-${index}`}
            data-bs-parent="#technicalAssistanceAccordion"
          >
            <div className="accordion-body">
              {item.summary}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

        <ContactForm />
        <Footer />
    </>)
}

export default TechnicalAssistance